var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunny01 = function SvgSunny01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.94,
    y1: 166.06,
    x2: 170.05,
    y2: 29.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 33.94,
    y1: 166.06,
    x2: 170.05,
    y2: 29.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.58,
    y1: 141.69,
    x2: 145.68,
    y2: 5.59,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100,153.38c29.48,0,53.38-23.9,53.38-53.38s-23.9-53.38-53.38-53.38-53.38,23.9-53.38,53.38,23.9,53.38,53.38,53.38M100,163.08c34.84,0,63.08-28.24,63.08-63.08s-28.24-63.08-63.08-63.08-63.08,28.24-63.08,63.08,28.24,63.08,63.08,63.08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.25,2.73c3.76-3.64,9.73-3.64,13.5,0l18.91,18.3,26.06-3.69c5.18-.73,10.01,2.78,10.92,7.93l4.55,25.92,23.24,12.33c4.62,2.45,6.47,8.13,4.17,12.83l-11.56,23.64,11.56,23.64c2.3,4.7.45,10.38-4.17,12.84l-23.24,12.33-4.55,25.92c-.9,5.16-5.73,8.67-10.92,7.93l-26.06-3.69-18.91,18.3c-3.76,3.64-9.73,3.64-13.5,0l-18.91-18.3-26.06,3.69c-5.18.73-10.01-2.78-10.92-7.93l-4.55-25.92-23.24-12.33c-4.62-2.45-6.47-8.13-4.17-12.84l11.56-23.64-11.56-23.64c-2.3-4.7-.45-10.38,4.17-12.83l23.24-12.33,4.55-25.92c.9-5.16,5.73-8.66,10.92-7.93l26.06,3.69L93.25,2.73ZM118.91,28l-18.91-18.3-18.91,18.3c-2.15,2.08-5.14,3.05-8.11,2.63l-26.06-3.69-4.55,25.92c-.52,2.95-2.37,5.49-5.01,6.9l-23.25,12.33,11.56,23.64c1.31,2.69,1.31,5.83,0,8.52l-11.56,23.64,23.25,12.33c2.64,1.4,4.49,3.95,5.01,6.9l4.55,25.92,26.06-3.69c2.96-.42,5.96.55,8.11,2.63l18.91,18.3,18.91-18.3c2.15-2.08,5.14-3.05,8.11-2.63l26.06,3.69,4.54-25.92c.52-2.95,2.37-5.49,5.01-6.9l23.24-12.33-11.56-23.64c-1.31-2.69-1.31-5.84,0-8.52l11.56-23.64-23.24-12.33c-2.64-1.4-4.49-3.95-5.01-6.9l-4.54-25.92-26.06,3.69c-2.96.42-5.96-.55-8.11-2.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.41,63.12c1.61,2.14,1.17,5.19-.97,6.79l-2.17,1.63c-7.25,5.44-12.63,12.99-15.39,21.63l-1.07,3.35c-.82,2.55-3.55,3.96-6.1,3.14-2.55-.82-3.96-3.55-3.14-6.1l1.07-3.34c3.38-10.55,9.95-19.79,18.81-26.43l2.17-1.63c2.14-1.61,5.19-1.17,6.79.97"
  })));
};
export default SvgSunny01;